export const localUrlMapping = [
	{
		url: 'localhost',
		institutionId: '2471',
		cxUrl: 'http://localhost:5152'
	}
];

export const qaUrlMapping = [
	{
		url: 'tcm-qa-lp.creditsnap.com',
		institutionId: 'TCM',
		cxUrl: 'https://tcm-qa-cx.creditsnap.com'
	},
	{
		url: 'bbok-qa-lp.creditsnap.com',
		institutionId: 'BBOK',
		cxUrl: 'https://bbok-qa-cx.creditsnap.com'
	},
	{
		url: 'bbow-qa-lp.creditsnap.com',
		institutionId: '2471',
		cxUrl: 'https://bbow-qa-cx.creditsnap.com'
	},
	{
		url: '2512-qa-lp.creditsnap.com',
		institutionId: '2512',
		cxUrl: 'https://2512-qa-cx.creditsnap.com'
	}

];

export const uatUrlMapping = [
	{
		url: 'tcm-lp.creditsnap.com',
		institutionId: 'TCM',
		cxUrl: 'https://tcm-cx.creditsnap.com'
	},
	{
		url: 'bbok-lp.creditsnap.com',
		institutionId: 'BBOK',
		cxUrl: 'https://bbok-cx.creditsnap.com'
	},
	{
		url: 'bbow-lp.creditsnap.com',
		institutionId: '2471',
		cxUrl: 'https://bbow-cx.creditsnap.com'
	},
		{
		url: '2512-lp.creditsnap.com',
		institutionId: '2512',
		cxUrl: 'https://2512-cx.creditsnap.com'
	}
];


export const stagingUrlMapping = [
	{
		url: 'tcm-stg-lp.creditsnap.com',
		institutionId: 'TCM',
		cxUrl: 'https://tcm-stg-cx.creditsnap.com'
	},
	{
		url: 'bbok-stg-lp.creditsnap.com',
		institutionId: 'BBOK',
		cxUrl: 'https://bbok-stg-cx.creditsnap.com'
	},
	{
		url: 'bbow-stg-lp.creditsnap.com',
		institutionId: '2471',
		cxUrl: 'https://bbow-stg-cx.creditsnap.com'
	},
		{
		url: '2512-stg-lp.creditsnap.com',
		institutionId: '2512',
		cxUrl: 'https://2512-stg-cx.creditsnap.com'
	}
];

export const prodUrlMapping = [
	{
		url: 'mycommunityccard.com',
		institutionId: 'TCM',
		cxUrl: 'https://apply.mycommunityccard.com'
	},
    {
        url: 'mycommunitycc.com',
        institutionId: 'TCM',
        cxUrl: 'https://apply.mycommunityccard.com'
    },
    {
        url: 'www.mycommunityccard.com',
        institutionId: 'TCM',
        cxUrl: 'https://apply.mycommunityccard.com'
    },
    {
        url: 'www.mycommunitycc.com',
        institutionId: 'TCM',
        cxUrl: 'https://apply.mycommunityccard.com'
    },
    {
        url: 'wwww.lp.apply.cardsupportcenter.com',
        institutionId: 'BBOK',
        cxUrl: 'https://apply.cardsupportcenter.com'
    },
    {
        url: 'lp.apply.cardsupportcenter.com',
        institutionId: 'BBOK',
        cxUrl: 'https://apply.cardsupportcenter.com'
    }
];

